import validationRules from "../validationRules";
validationRules.register("phone", function (record, fieldMetadataMap, fieldName, t) {
    var phone = record[fieldName];
    if (phone === "" || phone === undefined) {
        return true;
    }
    else {
        var result = /^(\+?\d{1,3}[-. ]?)?(\(?\d{3}\)?[-. ]?)?[\d-. ]{7,10}$/.test(phone);
        if (result) {
            return true;
        }
        //return t("validation.error.phone");
        return "Invalid phone number.";
    }
});
